import { contrastColor } from '../utils/color';

export interface ColorChipItem {
  id: string;
  nome: string;
  color: string;
}

/**
 * Multi-select a chip colorati (toggle on/off), usato per canali e settori
 * merceologici sia nei form sia nei filtri delle liste.
 */
export default function ColorChipPicker({
  items,
  selected,
  onChange,
  disabled,
  emptyText,
}: {
  items: ColorChipItem[];
  selected: string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
  emptyText?: string;
}) {
  if (items.length === 0) {
    return emptyText ? <p className="text-sm text-gray-500">{emptyText}</p> : null;
  }

  const toggle = (id: string) =>
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => {
        const active = selected.includes(item.id);
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => toggle(item.id)}
            disabled={disabled}
            aria-pressed={active}
            className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              active
                ? 'border-transparent'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
            style={active ? { backgroundColor: item.color, color: contrastColor(item.color) } : undefined}
          >
            {item.nome}
          </button>
        );
      })}
    </div>
  );
}
